import {DEFAULT_LOG_TEMPLATE} from './constants';

// NOTE: jQuery checking
if (!('$' in window) || typeof window.$ !== 'function') {
  throw Error(`${DEFAULT_LOG_TEMPLATE} missing jQuery library on page`);
}

// NOTE: Cookies checking
if (!('Cookies' in window) || typeof window.Cookies !== 'function') {
  throw Error(`${DEFAULT_LOG_TEMPLATE} missing Cookies library on page`);
}

// NOTE: RSVP checking
if (!('RSVP' in window) || typeof window.RSVP !== 'object') {
  throw Error(`${DEFAULT_LOG_TEMPLATE} missing RSVP library on page`);
}

// NOTE: InView jQuery Plugin checking
if (!('event'   in window.$) ||
    !('special' in window.$.event) ||
    !('inview'  in window.$.event.special) ||
    typeof window.$.event.special.inview !== 'object'
) {
  throw Error(`${DEFAULT_LOG_TEMPLATE} missing InView jQuery plugin on page`);
}



// WEBPACK FOOTER //
// ./src/check-dependencies.js